module.exports = __webpack_public_path__ + "media/images/exception_handler/stairs-aca4984cc3059200259566fafe996e43.png";